export const PURCHASED = "1";
export const LEASED = "2";
export const TBD = "TBD";

export default Object.freeze({
  [PURCHASED]: "Purchased",
  [LEASED]: "Leased",
  [TBD]: "TBD"
});
